import React, { Component } from 'react'
import { auth } from './firebase'


class Logout extends Component {
  state = {
    loader: true,
  };
  logout = () => {
    localStorage.clear()
    document.cookie = "AuthenticatedUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.canopytax.com; path=/;";
    this.props.clearUser();
    auth.signOut().catch(err => {
      alert(err.message)
    });
  };
  componentWillMount = () => {
    const { location } = this.props;
    const queryString = require('query-string');
    const qs = queryString.parse(location.search);
    if ('redirect_to' in qs) {
      localStorage.setItem('redirect_to', atob(decodeURIComponent(qs.redirect_to)))
    }
    this.logout();
    window.location = localStorage.getItem('redirect_to') || '/'
  };
  render() {
    return <div/>
  }
}

export default Logout



// WEBPACK FOOTER //
// ./src/logout.js